module.exports = __webpack_public_path__ + "static/media/license_a1.f3a402a2.png";